module.exports = __webpack_public_path__ + "img/list-icon.a9e223a5.png";